import AppImage from '@teamnovu/vue-cloudinary-image-statamic'

export default defineNuxtPlugin((nuxtApp) => nuxtApp.vueApp.use(AppImage, {}))
